<!--
 * @Author: your name
 * @Date: 2021-03-30 22:10:31
 * @LastEditTime: 2021-06-12 18:13:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\components\Footer.vue
-->
<template>
    <div class="footer_box">
        <div class="footer_con">
            Copyright © 2016 - {{ years }} 淘韓網 taohan.kr 版權所有
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            years: "",
        };
    },
    created() {
        this.getYears();
    },
    methods: {
        getYears() {
            const myDate = new Date();
            this.years = myDate.getFullYear();
        },
    },
};
</script>

<style scoped lang="scss">
.footer_box {
    background-color: #3a3a3a;
    color: #fff;
    margin-top: 20px;
    .footer_con {
        height: 100px;
        line-height: 100px;
        width: 1240px;
        text-align: center;
        margin: 0 auto;
    }
}
</style>
